import axios from "axios";

const { REACT_APP_MY_ENV } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_MY_ENV,
});

export function getPaymentHistory(endDate, startDate) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/referral/payments",
      params: {
        startingDate: startDate,
        endingDate: endDate,
      },
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function getPayments() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/payments",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
